const messages = {
  nomeUni: " Istituto Patristico Augustinianum",
  email: "Correo electrónico",
  password: "Contraseña",
  testoLogo: "testoLogo",
  semestre: "Semestre",
  NonDefinito: "-- Indefinido --",
  carattereNonValido: "¡Has introducido un caracter invalido!",
  presentazione:
    "Bienvenidos a la página de inscripción para el año académico {annoaccaS}/{annoaccaF}",
  cardCompleta: "Terminado",
  cardDaCompletare: "Completar",
  conferma: "El confirma",
  chiudi: "Cancelar",
  avanti: "Adelante",
  indietro: "Regresa",
  campiObbligatori: "* Indica los campos obligatorios",
  campoObbligatorio: "Campo requerido",
  checkCampiObbligatori: "¡Rellena todos los campos obligatorios!",
  tastoStep: { compila: "Llenar", modifica: "Editar" },
  si: "SÍ",
  no: "NO",
  errore: "¡Atención! Se ha producido un error.",
  chiuse:
    "Atención, las inscripciones están cerradas, consulta el calendario en la web de la Universidad.",
  salva: "Ahorrar",
  stepCompilati_1: "Has rellenado",
  stepCompilati_2: "de {step} formularios ",
  stepCompletati:
    "Has rellenado todos los formularios. Ahora haga clic en el botón de registro para enviar la solicitud de registro.",
  noData: "¡No se han encontrado resultados!",
  login: {
    confermaReset:
      "Si los datos introducidos son correctos, en unos minutos recibirás la nueva contraseña en tu dirección de correo electrónico.",
    nuovoStudente: {
      titolo: "¿Eres un nuevo estudiante?",
      testo:
        'Si quieres iniciar el procedimiento de matrícula en la Universidad, haz clic en el botón "Iniciar sesión" e introduce tu correo electrónico. Recibirás la contraseña de acceso a tu dirección de correo electrónico, con la que podrás completar el formulario.',
    },

    vecchioStudente: {
      titolo: "¿Es usted ya uno de nuestros estudiantes?",
      testo:
        "Si eres estudiante del Patristicum y tienes un número de estudiante, haz clic aquí:",
    },
    titolo: "Accede a tu formulario de registro",
    accedi: "Acceso",
    forgotPassword: "¿Has olvidado tu contraseña?",
    noRegistrato: "Todavía no estas registrado?",
    registrati: "Iniciar sesión",
    recuperoPassword: "Recuperación de contraseña",
    recuperoPasswordLabel:
      "Ingrese la dirección de correo electrónico con la que se registró *",
    registrazioneUtente:
      "Introduce tu dirección de correo electrónico, te enviaremos las credenciales para acceder al procedimiento de registro",
    registrazioneUtenteConferma:
      "Te enviamos un correo electrónico, ¡revisa tu bandeja de entrada!",
    registrazioneUtenteEmailEsistente: "Correo electrónico ya registrado",
    recupera: "Recuperar",
    emailNonValida: "¡Formato de correo inválido!",
    loginErrato: "¡Correo o contraseña incorrectos!",
    domandaInLavorazione:
      "Su solicitud de registro está siendo procesada. No se pueden realizar cambios.",
    statoPresentata:
      "Ya se ha registrado una solicitud de inscripción, cualquier envío de una nueva solicitud supondrá la cancelación de la anterior.",
  },

  logOut: {
    domanda: "¿Quieres cerrar la aplicación?",
    nota: "<b>Recuerde guardar o perderá toda la información que ingresó.</b>",
  },
  istruzioni: {
    tasto: "Instrucciones",
    esci: "Salir de la guía",
    avanti: "Adelante",
    indietro: "Regresa",
    fine: "Fin de la guía",
    step1: "Comience aquí completando el primer formulario",
    step2:
      "Si lo deseas, puedes guardar tus datos temporalmente. ¡Podrá completar su solicitud de inscripción más adelante! ",
    step3:
      "Una vez que hayas completado todos los formularios, podrás enviar tu solicitud de registro",
  },

  introduzione: {
    titolo: "Norme e Condizioni",
    testo_iniziale:
      "Per proseguire è necessario il consenso al trattamento dei dati conformemente alle disposizioni normative vigenti, ivi incluse quelle in materia di protezione dei dati personali (Regolamento Europeo 679/2016)",
    testo_consenso:
      "<br>Consenso al trattamento in rapporto alle finalità esplicitate al punto 2) lettere a) b) c) d) della Informativa ai sensi dell’art. 13 del Regolamento Europeo 679/2016.<br>Il sottoscritto acconsente al trattamento dei dati personali che lo riguardano, in rapporto alle seguenti finalità (barrare la finalità per cui il consenso viene esplicitato):",
    tasto_informativa:
      "Informativa ai sensi dell'art. 13 del Regolamento Europeo 679/2016",
    consenso1:
      "adempimento degli obblighi contrattuali assunti dall’Università Gregoriana nei miei confronti (obbligatorio);",
    consenso2:
      "adempimento degli obblighi di natura legale, fiscale e statutaria connessi, o comunque derivanti, dalla mia iscrizione presso l’Università Gregoriana (obbligatorio);",
    consenso3:
      "di pubblicazione all’interno dei documenti ufficiali dell’Università quali: annuario degli studenti, Ordo Anni Accademici, Liber Annualis, inaugurazione dell’anno accademico;",
    consenso4:
      "pubblicitaria, in relazione all’organizzazione di iniziative di carattere benefico, convegni, seminari, corsi di studio gestiti, o patrocinati o in altro modo sponsorizzati o promossi, da parte dell’Università Gregoriana.",
    consenso_norme_condotta:
      "Norme di condotta nel caso di molestie sessuali e morali.",
    conferma: "Ho capito",
  },

  anagrafica: {
    titolo: "Información personal",
    cognome: "Apellido",
    nome: "Nombre de pila",
    datanascita: "Fecha de nacimiento (gg/mm/aaaa)",
    nazionenascita: "Nación de nacimiento",
    comunenascita: "Lugar de nacimiento",
    statocivile: "Estado civil",
    linguamadre: "Lengua materna",
    sesso: "Sexo",
    religione: "Religión",
    cittadinanza: "Ciudadanía",
    "2cittadinanza": "2a Ciudadanía",
    ordinereligioso: "Orden religiosa",
    codicefiscale: "Código de identificación fiscal",
    fototessera: "Subir foto de pasaporte",
    fototesseraInfo: "Sube una imagen en formato JPG",
    CFNoValido: "Código fiscal no válido",
    copiaResidenza: "Copiar los datos de la Residencia",
    diocesi: "Diócesis",
    collegio: "Colega",
  },

  indirizzi: {
    titolo: "Introduce tus datos de contacto",
    titoloResidenza: "Residencia en el país de origen",
    titoloRecapito: "Domicilio",
    cap: "CÓDIGO Postal",
    nazione: "Nación",
    comune: "Común",
    telefono: "Teléfono",
    indirizzo: "DIRECCIÓN",
    presso: "En",
    cellulare: "Número de teléfono móvil",
    formatoCap: "¡Formato incorrecto!",
  },

  studiprevi: {
    titolo: "Estudios previos y conocimiento de idiomas.",
    studiPreuni: "Estudios preuniversitarios",
    studiFilosofia: "Estudios de filosofía",
    studiTeologia: "Estudios de teología",
    studiAltro: "Otros Estudios (Letras, Derecho, Historia, Psicología, etc.)",
    titoloStudio: "Calificación",
    istituto: "Istituto",
    anno: "Año de Graduación",
    votazione: "Votar",
    lingue: {
      titolo: "Conocimiento de idiomas",
      antiche: "Lenguas antiguas",
      latina: "Latín",
      greca: "Griego",
      ebraica: "Judío",
      moderne: "Lenguajes modernos",
      francese: "Francés",
      inglese: "Inglés",
      italiana: "Italiano",
      spagnola: "Español",
      tedesca: "Alemán",
      livello: {
        discreto: "Discreto",
        buono: "Bien",
        eccellente: "Excelente",
      },
      reset: "Reiniciar",
    },
  },

  iscrizione: {
    titolo: "Elija el ciclo de estudio",
    facolta: "Facultad",
    unita_accademica: "Unidad Académica",
    ciclo: "Ciclo de estudio",
    specializzazione: "Especialización",
    annodicorso: "Año de estudio",
    tipoiscrizione: "Tipo de registro",
    categoria: "Categoria",
    domandaOspite: "¿Quieres registrarte como estudiante invitado?",
    cambioIscrizione:
      "Atención, has cambiado tu inscripción. Es necesario confirmar nuevamente la carga de documentos y la elección de cursos.",
    infoCategoria:
      "Invitado es el estudiante que solo asiste a unos pocos cursos (máximo 3 por semestre)",
    infoAnnoCorso: "1 - Primer año <br> 2 - Segundo año <br> 3 - Tercer año",
    infoIscrizione: "",
    scegliciclo: "Seleccione primero el ciclo de estudio",
    sceglianno: "Seleccione primero el ciclo de estudio",
    infoCategoriaORDSTR:
      "Extraordinario es el estudiante que no reúne los requisitos necesarios para obtener un título académico.",
    notaFacolta: "Nota de la facultad",
    confermaNota: "He leído la nota",
  },

  documenti: {
    titolo: "Documentos necesarios para el registro.",
    caricaFile: "Sube el archivo ({formato})",
    fileCaricato: "Archivo cargado exitosamente",
    fileObbligatorio: "¡Documento obligatorio!",
    fileTooBig: "¡Archivo demasiado grande! (max 2 MB)",
    fileErrato: "¡Formato de archivo incorrecto!",
    anteprima: "Avance",
    cancella: "Cancelar",
    foto: "Tu foto",
    istruzioniFoto:
      "Mueve el marco de abajo para enmarcar tu rostro correctamente (también puedes ampliar la imagen). Mire la vista previa de su insignia en el cuadro de la derecha. Para confirmar su elección haga clic en el botón 'CONFIRMAR'",
    anteprimaBadge: "Vista previa de la insignia",
  },

  corsi: {
    seminariLettureChiuse:
      "Attenzione, le Iscrizioni sono terminate. Non è più possibile scegliere Seminari e Letture Guidate tramite la procedura on-line. In caso di necessità rivolgersi alla Segreteria di Facoltà",
    sem1: " (anual o 1er semestre)",
    sem2: " (2do semestre)",
    nonTrovato1Sem: "Curso inexistente o perteneciente al 2do semestre",
    nonTrovato2Sem: "Curso inexistente o perteneciente al 1er semestre",
    titolo: "Elección de cursos",
    corsi: "Cursos",
    seminari: "Seminarios",
    letture: "Lecturas guiadas",
    preparazione: "Preparando lista de cursos...Por favor espere",
    ricerca: "Buscar (Curso, Profesor, Título)",
    di: "de",
    nocorsi: "No hay {tipocorso} para el ciclo de estudio seleccionado.",
    tuttiCorsi: "Ver cursos de todas las facultades",
    selezionati: "Seleccionado",
    selezionatiOrdinati:
      "Para cambiar el orden de preferencia, arrastre la fila de interés o elimine el curso incorrecto",
    obbligatori: "El curso se agregará automáticamente a tu plan de estudios.",
    aggiungi: "Agregar",
    aggiunto: "El curso &nbsp;<b>{corso}</b>&nbsp; ¡ha sido añadido!",
    giaScelto:
      "¡Atención! El curso &nbsp;<b>{corso}</b>&nbsp; ¡Ya ha sido elegido!",
    cancellazione: "¿Quieres cancelar el curso {corso} ?",
    attenzione: "¡Atención!",
    maxCorsi:
      "Has alcanzado el número máximo de cursos que se pueden seleccionar para la ruta de estudio elegida.",
    maxSeminari:
      "Has alcanzado el número máximo de seminarios que se pueden seleccionar para el plan de estudios elegido.",
    maxLetture:
      "Has alcanzado el número máximo de lecturas guiadas que se pueden seleccionar para el itinerario de estudios elegido.",
    minCorsi:
      "Aún tienes que elegir n°{corsi} curso| Aún tienes que elegir n°{corsi} cursos",
    minCorsiOK: "¡Has elegido el número mínimo de cursos necesarios!",
    minSeminari: "Aún tienes que elegir n°{corsi} seminarios",
    minSeminariOK: "¡Has elegido el número mínimo de seminarios necesarios!",
    minLetture: "Aún tienes que elegir n°{corsi} lecturas guiadas",
    minLettureOK:
      "¡Has elegido el número mínimo de lecturas guiadas necesarias!",
    nessunaSelezione: "¡Aún no hay cursos seleccionados!",
    noScelta:
      "¡Atención, para el ciclo de estudios seleccionado es necesario elegir al menos {minCorsi} cursos!",
    troppiCorsi:
      "Atención, para el ciclo de estudios seleccionado puedes elegir un máximo de {maxCorsi} cursos!",
    noSceltaSeminari:
      "¡Atención, para el ciclo de estudios seleccionado es necesario elegir al menos {minCorsi} seminarios!",
    troppiSeminari:
      "Atención, para el ciclo de estudios seleccionado puedes elegir un máximo de {maxCorsi} seminarios!",
    noSceltaLetture:
      "¡Atención, para el ciclo de estudios seleccionado es necesario elegir al menos {minCorsi} lecturas guiadas!",
    troppiLetture:
      "Atención, para el ciclo de estudios seleccionado puedes elegir un máximo de {maxCorsi} lecturas guiadas!",
    corsiOspitiFuoriFacolta:
      "Atención, debes elegir al menos un curso de la Facultad de: {facolta}",
    avvisoDogmatica:
      "Se questo semestre vuoi seguire un seminario, indica 3 scelte; se ne vuoi seguire due, aggiungi altre 3 scelte (totale 6 scelte per ordine di preferenza).",
  },

  invioRichiesta: {
    btnInvio: "ENVIAR LA SOLICITUD DE INSCRIPCIÓN",
    domanda: "¿Quieres enviar la solicitud de inscripción?",
    nota: "La Secretaría procesará su solicitud lo antes posible",
    btnConferma: "SÍ",
    btnAnnulla: "Cancelar",
    fine: {
      titolo: "¡Has terminado el procedimiento!",
      testo:
        "Tu solicitud ha sido enviada. En unos minutos recibirás un mensaje de correo electrónico con el resumen de tu solicitud de registro.",
    },
  },
  salvaDati: {
    info:
      "Guarde temporalmente los datos ingresados. Puede continuar completando el formulario más adelante.",
    domanda: "¿Quieres guardar la información ingresada hasta este momento?",
    nota: "Podrás completar la recogida de tus datos más adelante.",
    btnConferma: "SÍ",
    btnAnnulla: "Cancelar",
    fine: {
      titolo: "¡Los datos han sido guardados!",
      testo: "",
    },
  },
};

export default messages;
